import { __awaiter } from "tslib";
import { FacadeRegistry } from "./facade-registry";
import { EventServiceErrorType } from "./plugins/eventservice";
// jweb-core version that the EventService plugin interface was last updated.
export const eventServiceFacadeVersion = {
    major: 4,
    minor: 2,
    patch: 0
};
export const isStartingPausedNotSupportedError = () => {
    console.warn('isStartingPaused is not supported.');
    const error = {
        errorType: EventServiceErrorType.isStartingPausedNotSupported,
        reason: 'isStartingPaused is not supported.'
    };
    return error;
};
export const subscriptionHandlesNotSupportedError = () => {
    console.warn('SubscriptionHandles is not supported.');
    const error = {
        errorType: EventServiceErrorType.subscriptionHandlesNotSupported,
        reason: 'SubscriptionHandles is not supported.'
    };
    return error;
};
//Facade to handle older version of EventService for subscriptionHandles and isStartingPaused
export const eventServiceFacade = (jWeb) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!jWeb.isPluginAvailable('EventService')) {
        // Cannot update methods if EventService is not available
        return;
    }
    const eventServicePlugin = (_a = jWeb.Plugins) === null || _a === void 0 ? void 0 : _a.EventService;
    // Handle the subscriptionHandles and isStartingPaused when getSupportedInterfaceVersion returns an older version.
    const eventServiceSupportVersion = yield FacadeRegistry.pluginSupportsInterfaceVersion(eventServicePlugin, "EventService", { major: 4, minor: 1, patch: 1, });
    if (!eventServiceSupportVersion) {
        if (eventServicePlugin.createSubscriber) {
            const createSubscriberOriginal = eventServicePlugin.createSubscriber;
            eventServicePlugin.createSubscriber = (options) => __awaiter(void 0, void 0, void 0, function* () {
                if (options === null || options === void 0 ? void 0 : options.isStartingPaused) {
                    return isStartingPausedNotSupportedError();
                }
                const subscriberResult = yield createSubscriberOriginal(options);
                if (FacadeRegistry.isSubscriber(subscriberResult)) {
                    if (subscriberResult.getSubscriptionHandles == undefined) {
                        console.log('FacadeRegistry::eventServicePluginFacade: Attaching getSubscriptionHandles method');
                        subscriberResult.getSubscriptionHandles = () => Promise.resolve(subscriptionHandlesNotSupportedError());
                    }
                }
                return subscriberResult;
            });
        }
    }
    jWeb.Plugins.EventService = eventServicePlugin;
});
//# sourceMappingURL=eventServiceFacade.js.map